"use client";

import AdDetailModel from "@/models/AdDetailModel";
import AdDetailsPageLayout from "./AdDetailsPageLayout";
import AdNav from "./AdNav";
import DetailsGallery from "./Gallery/DetailsGallery";
import AdDetailRibbons from "./AdDetailRibbons";
import AdBody from "./AdBody";
import AdAside from "./AdAside";
import { useEffect, useRef } from "react";
import { RecaptchaProvider } from "@/app/layout/useRecaptcha";
import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";
import { AdManagerProvider } from "@/app/layout/useAdManager";
import { DETAILS_ADS } from "../ads";
import { AdReportButton } from "@/app/shared/ad/AdReportButton";

export default function AdDetailsPage({ ad }: { ad: AdDetailModel }) {
  const enquiryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    CreateAnalyticEvent({
      event: {
        adIds: [ad.id],
        eventType: ad.isInactive ? "AD_VIEW#INACTIVE" : "AD_VIEW",
      },
    });
  }, [ad.id, ad.isInactive]);

  return (
    <AdManagerProvider ads={DETAILS_ADS}>
      <AdDetailsPageLayout
        nav={
          <AdNav
            ad={ad}
            onContactSellerClicked={() => {
              if (enquiryRef.current) {
                enquiryRef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
            }}
          />
        }
        gallery={<DetailsGallery adId={ad.id} gallery={ad.gallery} />}
        prebody={<AdDetailRibbons ad={ad} />}
        body={<AdBody ad={ad} />}
        footer={<AdReportButton ad={ad} />}
        aside={
          <RecaptchaProvider>
            <AdAside ad={ad} innerRef={enquiryRef} />
          </RecaptchaProvider>
        }
        hideAds={ad.sellerIsHideAds}
      />
    </AdManagerProvider>
  );
}
